import { IconButton, IconButtonProps, Text, VStack } from "@chakra-ui/react";
import * as React from "react";
import { LuTrash } from "react-icons/lu";

import { Button } from "./button";
import {
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverRoot,
  PopoverTitle,
  PopoverTrigger,
} from "./popover";

export interface DeleteButtonProps extends IconButtonProps {
  label: string;
  message: string;
  onDelete: () => void;
}

export function DeleteButton({
  label,
  message,
  onDelete,
  ...rootProps
}: DeleteButtonProps) {
  return (
    <PopoverRoot>
      <PopoverTrigger asChild>
        <IconButton
          aria-label="Delete"
          colorPalette="red"
          size="xs"
          {...rootProps}
        >
          <LuTrash />
        </IconButton>
      </PopoverTrigger>
      <PopoverContent>
        <PopoverArrow />
        <PopoverBody>
          <PopoverTitle fontWeight="medium">{message}</PopoverTitle>
          <VStack align="left">
            <Text my="4">This action cannot be undone.</Text>
            <Button colorPalette="red" onClick={onDelete}>
              {label}
            </Button>
          </VStack>
        </PopoverBody>
      </PopoverContent>
    </PopoverRoot>
  );
}
